import { render } from "./PoweredByInspiration.vue.js?vue&type=template&id=0337147f!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PoweredByInspiration.vue?vue&type=template&id=0337147f"
import script from "./PoweredByInspiration.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PoweredByInspiration.vue?vue&type=script&lang=js"
export * from "./PoweredByInspiration.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PoweredByInspiration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/login-signup-page/join-publication/PoweredByInspiration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0337147f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0337147f', __exports__)) {
    api.reload('0337147f', __exports__)
  }
  
  module.hot.accept("./PoweredByInspiration.vue.js?vue&type=template&id=0337147f!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PoweredByInspiration.vue?vue&type=template&id=0337147f", () => {
    api.rerender('0337147f', render)
  })

}


export default __exports__